import { authConstants } from './../constants/auth-constants';
import  ConfigurationService  from './../services//configuration-service'

export const agentLimitList = (data) => async (dispatch) => {
    try {
      const res = await ConfigurationService.getAgentLimitList();
      dispatch({
        type: authConstants.AGENT_LIMIT_LIST,
        payload: res.data,
      });
 
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }
  };